export default [
  {
    path: '/home',
    name: 'home-index',
    component: () => import('../views/home/product/index.vue'),
    meta: {
      parent: 'main',
      enum: ['openState', 'productListType', 'financeState'],
    },
  },
  // 模拟融资成功失败
  {
    path: '/financeSpace',
    name: 'finace-space',
    component: () => import('../views/open/FinanceSpace.vue'),
  },
  // 模拟开通成功失败
  {
    path: '/openSpace',
    name: 'open-space',
    component: () => import('../views/open/OpenSpace.vue'),
  },
  // 模拟还款成功失败
  {
    path: '/repaySpace',
    name: 'repay-space',
    component: () => import('../views/open/RepaySpace.vue'),
  },
  // 模拟流程进度
  {
    path: '/processSpace',
    name: 'process-index',
    component: () => import('../views/open/ProcessSpace.vue'),
  },
  {
    path: '/open',
    name: 'open',
    meta: {
      enum: ['financeState'],
    },
    component: () => import('../views/open/Flow.vue'),
  },
  {
    path: '/openCG',
    name: 'openCG',
    meta: {
      enum: ['financeState'],
    },
    component: () => import('../views/open/FlowCG.vue'),
  },

  {
    path: '/receivable',
    name: 'receivable',
    component: () => import('../views/trade/receivable/index.vue'),
    meta: {
      title: '应收账款',
      parent: 'main',
      enum: ['financeState'],
      keepAlive: true,
    },
  },
  {
    path: '/receivable-detail/:subjectNo',
    name: 'receivable-detail',
    component: () => import('../views/trade/receivable/Detail.vue'),
    meta: {
      title: '',
      enum: ['financeState', 'financeApplyState'],
    },
  },
  {
    path: '/order-detail',
    name: 'order-detail',
    component: () => import('../views/trade/order/Detail.vue'),
    meta: {
      title: '',
      enum: ['financeState', 'financeApplyState'],
    },
  },
  {
    path: '/process',
    name: 'process',
    component: () => import('../views/trade/process/ProcessIndex.vue'),
    meta: {
      parent: 'main',
      title: '授信进度查询',
      enum: ['creditState', 'creditType', 'financeApplyState', 'financeState'],
      keepAlive: true,
    },
  },
  {
    path: '/enterprise',
    name: 'fancing',
    component: () => import('../views/enterprise/index.vue'),
    meta: {
      title: '企业信息',
      parent: 'main',
      enum: ['customerType', 'opDateType', 'certType'],
    },
  },
  {
    path: '/finance',
    name: 'finance',
    component: () => import('../views/trade/finance/index.vue'),
    meta: {
      title: '融资记录',
      parent: 'main',
      enum: ['loanStatus', 'financeState', 'repayMode', 'settleState'],
      keepAlive: true,
    },
  },
  {
    path: '/product/detail',
    name: 'product-index',
    component: () => import('../views/home/product/Detail.vue'),
    meta: {
      enum: ['productState', 'loanStatus'],
    },
  },
  // 进度详情
  {
    path: '/process/financing/detail',
    name: 'financing-detail',
    component: () => import('../views/trade/process/FinancingDetail.vue'),
    meta: {
      enum: ['financeApplyState', 'financeState'],
      keepAlive: true,
    },
  },
  // 我的融资详情
  {
    path: '/finance/detail',
    name: 'finance-detail',
    component: () => import('../views/trade/finance/Detail.vue'),
    meta: {
      enum: ['loanStatus', 'repayPlanLifecycle', 'repayMode', 'financeState', 'settleState'],
    },
  },
]
